import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";

// A required dropdown in the look shared by the "פתיחת קריאה" form
const FormSelect = ({ id, label, value, onChange, options }) => (
  <FormControl fullWidth required>
    <InputLabel id={`${id}-label`}>{label}</InputLabel>
    <Select
      labelId={`${id}-label`}
      value={value}
      label={label}
      onChange={onChange}
      sx={{
        borderRadius: "8px",
        backgroundColor: "#fff",
      }}
    >
      {options.map((option) => (
        <MenuItem key={option} sx={{ direction: "ltr" }} value={option}>
          {option}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);

export default FormSelect;
